<template>
  <div class="container">
    <!--成员数据-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">成员数据</div>
        <div class="title-desc">
          成员签约工作室后，上传作品产生的收益及互动数据
        </div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">数据维度</span>
          <span class="btnGroup">
            <van-button
              @click="changeMembersDataType(1)"
              :class="{ active: membersDataType == 1 }"
              size="medium"
              >收益</van-button
            >
            <van-button
              @click="changeMembersDataType(2)"
              :class="{ active: membersDataType == 2 }"
              size="medium"
              >互动</van-button
            >
          </span>
        </div>
        <div class="data-filter">
          <date-selector
            v-model="membersDate"
            @change="membersDateChange"
            :queryBtnClick="handleMDateBtnClicked"
          ></date-selector>
        </div>
        <div class="data-filter">
          <span class="mgr25">成员类型</span>
          <span class="btnGroup">
            <van-button
              @click="changeMembersState(2)"
              :class="{ active: membersState == 2 }"
              size="medium"
              >当前成员</van-button
            >
            <van-button
              @click="changeMembersState(6)"
              :class="{ active: membersState == 6 }"
              size="medium"
              >退出/解散成员</van-button
            >
          </span>
        </div>
        <div
          class="data-table"
          v-if="membersData.length || membersViewData.length"
        >
          <my-table
            :tableData="membersData"
            :tableField="membersDataField"
            v-if="membersDataType == 1"
          >
            <template slot-scope="scope" slot="default">
              <span v-if="scope.row.key == 'vip'">
                {{
                  scope.row.value
                    | MemberITypeFilter(scope.row.fullData.position)
                }}
              </span>
            </template>
          </my-table>

          <my-table
            :tableData="membersViewData"
            :tableField="membersViewDataField"
            v-else
          >
            <template slot-scope="scope">
              <span v-if="scope.row.key == 'vip'">
                {{
                  scope.row.value
                    | MemberTypeFilter(scope.row.fullData.member_type)
                }}
              </span>
            </template>
            <template slot-scope="scope" slot="opt-slot">
              <span
                class="all-look"
                v-if="scope.row.vip"
                @click="
                  $router.push({
                    name: 'detailPage',
                    params: {
                      member_id: scope.row.uin,
                      member_type: scope.row.member_type,
                    },
                  })
                "
              >
                查看详情
              </span>
              <span class="all-look" v-else @click="toastMessage">
                查看详情
              </span>
            </template>
          </my-table>
          <van-loading
            class="img-loading"
            type="spinner"
            color="#fd9b21"
            size="24px"
            v-show="membersDataLoading"
          />
        </div>
        <NoData v-else></NoData>
        <div class="data-filter-page" v-if="membersDataType == 1">
          <Pagination
            :tableInfo="membersPagination"
            @changCurrentPage="mDPaginationChange"
          ></Pagination>
        </div>
        <div class="data-filter-page" v-else>
          <Pagination
            :tableInfo="membersViewPagination"
            @changCurrentPage="mVPaginationChange"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStudioMembersIncome, getStudioMembersOverview } from '@/api/studio';
//import {getStudioMembersIncome} from '@/api/studio';
import DateSelector from '../../../../components/DateSelector.vue';
import Pagination from '../../../income/components/pagination.vue';
import MyTable from '../../../../components/MyTable.vue';
import NoData from '@/components/NoData.vue';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  components: {
    DateSelector,
    Pagination,
    MyTable,
    NoData,
  },
  data() {
    return {
      membersDataField: [
        { label: '成员名称', prop: 'name' },
        { label: '', prop: '' },
        { label: '迷你号', prop: 'uin' },
        { label: '类型', prop: 'vip' },
        { label: '累计迷你豆', prop: 'minibean' },
        { label: '累计迷你点', prop: 'minipoint' },
        { label: '累计贡献点', prop: 'contribution' },
        { label: '星启激励A', prop: 'other_xingqi4_time' },
        { label: '星启激励B', prop: 'other_xingqi4_shop' },
        { label: '广告播放次数', prop: 'ad_count' },
        { label: '累计广告', prop: 'ad_shop' },
        { label: '其他收入', prop: 'other_newstar' },
      ],
      membersViewDataField: [
        { label: '成员名称', prop: 'name' },
        { label: '', prop: '' },
        { label: '迷你号', prop: 'uin' },
        { label: '类型', prop: 'vip' },
        { label: '作品数', prop: 'map_count' },
        { label: '最近上传', prop: 'add_map_last_time' },
        { label: '昨日下载', prop: 'yesterday_download_count' },
        { label: '累计下载量', prop: 'download_count' },
        { label: '操作', prop: 'operation' },
      ],
      membersDataLoading: false,
      membersDataType: '1',
      membersState: 2,
      membersPagination: {
        pageSize: 5,
        page: 1,
        total: 0,
      },
      membersViewPagination: {
        pageSize: 5,
        page: 1,
        total: 0,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      membersDate: '',
      lastMembersDate: [],
      membersData: [],
      membersViewData: [],
    };
  },
  created() {
    //const currTime = Date.now()
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.membersDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    this.getMembersData();
    this.getMembersViewData();
  },
  filters: {
    MemberTypeFilter(vip, type) {
      if (vip) {
        return type == 1 ? '室长' : '签约成员';
      } else {
        return '普通成员';
      }
    },
    MemberITypeFilter(vip, position) {
      if (vip) {
        if (position == 1) return '室长';
        else if (position == 2) return '签约成员';
        else return '管理员';
      } else {
        return '普通成员';
      }
    },
  },
  methods: {
    changeIncomeType(num) {
      this.incomeType = num;
    },
    handleMDateBtnClicked() {
      if (this.membersDataType == 1) {
        // if (this.lastMembersDate[0] === this.membersDate[0] && this.lastMembersDate[1] === this.membersDate[1]) return
        this.getMembersData();
      } else {
        this.getMembersViewData();
      }
    },
    membersDateChange(date, index) {
      console.log('membersDateChange', this.membersDate, date, index);
    },
    toastMessage() {
      this.$toast.fail('仅能查看签约成员数据哦');
    },
    changeMembersDataType(num) {
      this.membersDataType = num;
    },
    changeMembersState(state) {
      this.membersState = state;
    },
    mDPaginationChange(currPage) {
      this.membersPagination.page = currPage;
      this.getMembersData();
    },
    mVPaginationChange(currPage) {
      this.membersViewPagination.page = currPage;
      this.getMembersViewData();
    },
    async getMembersData() {
      this.membersDataLoading = true;
      this.lastMembersDate = this.membersDate;
      const res = await getStudioMembersIncome(
        Object.assign(
          {
            page_size: this.membersPagination.pageSize,
            page: this.membersPagination.page,
          },
          {
            start_time: parseInt(this.membersDate[0] / 1000, 10),
            end_time: parseInt((this.membersDate[1] + ONE_DAY_TIME) / 1000, 10),
            state: this.membersState,
          },
        ),
      );
      this.membersDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.membersData = list.map(item => {
            item.contribution = Number(item.contribution).toFixed(3);
            return item;
          });
        } else {
          this.membersData = [];
        }
        this.membersPagination.total = parseInt(res.data.total_count, 10);
      }
    },
    async getMembersViewData() {
      this.membersDataLoading = true;
      this.lastMembersDate = this.membersDate;
      const res = await getStudioMembersOverview(
        Object.assign(
          {
            page_size: this.membersViewPagination.pageSize,
            page: this.membersViewPagination.page,
          },
          {
            start_time: parseInt(this.membersDate[0] / 1000, 10),
            end_time: parseInt((this.membersDate[1] + ONE_DAY_TIME) / 1000, 10),
            json: 1,
            state: this.membersState,
          },
        ),
      );
      this.membersDataLoading = false;
      if (res.data.list.length) {
        this.membersViewData = res.data.list;
      } else {
        this.membersData = [];
      }

      this.membersViewPagination.total = parseInt(res.data.total_count, 10);
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container {
  .data-table {
    margin-top: 28px;
    // border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    /deep/ .table-content .table {
      margin: 0;
    }
    .all-look {
      color: #2b6ddf;
      text-decoration: underline;
      display: flex;
      justify-content: center;
    }
  }
  .all-look {
    color: #2b6ddf;
    text-decoration: underline;
    display: flex;
    justify-content: center;
  }
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
  }
}
</style>
